import { isDevMode } from '@angular/core';
import { environment } from '../src/environments/environment';

// module.exports = {
// //local
//  apiurl: 'http://localhost:3000/',

// //   //Dev server
// //   //apiurl:'http://70.35.199.150:3000/'

//  //Production server
//   //  apiurl: 'http://210.18.138.11:3000/'

//   dbConfig: {
//     server: 'KBS-TECH1050',
//     database: 'Tokaysql',
//     user: 'sa',
//      password: 'kbs@999',
//     options: {
//       encrypt: false // Use this if you're on Windows Azure
//     }
//    }

// }


export default {
  // local
//  apiurl:'http://localhost:4202/',

 // Dev server
 //apiurl:'http://70.35.199.150:3000/'

  //Production server
 //apiurl: 'http://108.175.2.39:3000/',
 //apiurl: '/api/',
 apiurl: environment.apiurl,
//  apiurl: isDevMode() ? 'http://localhost:3000/' : '/api/',
//  dbConfig: {
//    server: 'U21356133\\SQLSERVER2014',
//    database: '3RD_TokaySQL ',
//    user: 'sa',
//    password: 'dan@999',
//    options: {
//      encrypt: false // Use this if you're on Windows Azure
//    }
//  }
}
